import { createFileRoute } from '@tanstack/react-router';

import { EvidencePayrollPage } from '@/features/labour-evidence/payroll-page';

export const Route = createFileRoute('/_app/projects/$projectId/labour-evidence/payroll/')({
  component: EvidencePayrollRoute,
});

function EvidencePayrollRoute() {
  const { projectId } = Route.useParams();
  return <EvidencePayrollPage projectId={projectId} />;
}
